export default "/images/37c5347025cc74b36b2326c9b3418830.png";